import _ from 'underscore';
import { segmentationTree } from './segmentation-tree';

export function isSegmentationTypeSupported({
  type,
  permissions = {},
  tree = segmentationTree,
}) {
  return _.any(tree, ({ permission, children, name }) => {
    if (permission && !permissions[permission]) {
      return false;
    }

    if (children) {
      return isSegmentationTypeSupported({
        type,
        permissions,
        tree: children,
      });
    }

    return name === type;
  });
}
